module.exports = __webpack_public_path__ + "img/py.bbd9e248.svg";